module.exports = __webpack_public_path__ + "img/job-medium.66748308.svg";